import { render, staticRenderFns } from "./TelewizytaPanel.vue?vue&type=template&id=7d2e1582&scoped=true"
import script from "./TelewizytaPanel.vue?vue&type=script&lang=js"
export * from "./TelewizytaPanel.vue?vue&type=script&lang=js"
import style0 from "./TelewizytaPanel.vue?vue&type=style&index=0&id=7d2e1582&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2e1582",
  null
  
)

export default component.exports